<template>
  <div class="fintscore-report">

    <drawer-fintscore-report-history ref="drawer_fintscore_history" @open-purchase-report="openPurchaseReportDrawer" />
    <drawer-purchase-fintscore-report ref="drawer_purchase_fintscore_report"
      @new-purchase-report="$refs.drawer_fintscore_history.getCreditReportHistory()" />

    <PreviewModal ref="preview_modal"></PreviewModal>

    <b-card no-body>
      <b-card-header class="py-2 px-3 d-flex align-items-center justify-content-between">
        <h5 class="mb-0">FINTSCORE Report</h5>
        <el-button class="float-right py-0" type="text" @click="$refs.drawer_fintscore_history.openDrawer()">
          <small>Report History </small>
          <b-icon icon="chevron-right"></b-icon>
        </el-button>
      </b-card-header>
      <div class="px-3 py-2">
        <b-row class="align-items-center">
          <b-col cols="12" class="d-flex justify-content-center py-2">
            <b-button-group class="border w-100">
              <b-button class="border-right" :disabled="_gHlp.isEmpty(activeCreditReport.credit_report_fintscore_unsigned_url)" @click="$refs.preview_modal.preview(
                activeCreditReport.credit_report_fintscore_unsigned_url,
                'FINTSCORE Report: ' + activeCustomer.name
              )" variant="white">
                <b-icon icon="cloud-download" variant="primary"></b-icon>
                <h5 class="text-primary mb-0 mt-2">FINTSCORE Report</h5>
              </b-button>
              <b-button class="border-left" :disabled="_gHlp.isEmpty(activeCreditReport.credit_report_consent_unsigned_url)" @click="$refs.preview_modal.preview(
                activeCreditReport.credit_report_consent_unsigned_url,
                'Consent Form: ' + activeCustomer.name
              )" variant="white">
                <b-icon icon="cloud-download" variant="primary"></b-icon>
                <h5 class="text-primary mb-0 mt-2">Consent Form</h5>
              </b-button>
            </b-button-group>
          </b-col>
          <b-col cols="12" class="d-flex justify-content-center py-2">
            <b-button block variant="primary" @click="openPurchaseReportDrawer" v-if="activeCustomer && !activeCustomer.cjp_id">
              Purchase latest CTOS<br>
              <small>RM{{ discount_fintscore_price }} / Report</small>
            </b-button>
          </b-col>
          <b-col cols="12" class="d-flex justify-content-center py-2">
            <el-button type="danger" @click="syncFromSas" v-if="activeCustomer && !activeCustomer.cjp_id" icon="el-icon-refresh" class="w-100">
              Sync From SAS
            </el-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
import { Card, Button } from 'element-ui'
import { swal } from '@/assets/js/httpImports.js';
import DrawerPurchaseFintscoreReport from '@/views/CustomerProfile/Drawers/DrawerFintscoreReport/DrawerPurchaseFintscoreReport'
import DrawerFintscoreReportHistory from '@/views/CustomerProfile/Drawers/DrawerFintscoreReport/DrawerFintscoreReportHistory'

import PreviewModal from '@/components/Modal/PreviewModal'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import { useFintscoreStore } from '@/stores/fintscoreStore'

export default {
  name: 'fintscore-report',
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    DrawerPurchaseFintscoreReport,
    DrawerFintscoreReportHistory,
    PreviewModal
  },
  data() {
    return {
      is_loading_refresh: false,
    }
  },
  computed: {
    ...mapState(useCustomerStore, ['activeCustomer']),
    ...mapState(useCreditReportStore, ['activeCreditReport']),
    ...mapState(useFintscoreStore, ['fintscore_reports', 'discount_fintscore_price'])
  },
  methods: {
    ...mapActions(useCreditReportStore, ['getCreditReport','syncLatestSasCreditReport']),
    ...mapActions(useFintscoreStore, ['generateFintscoreReport', 'getAllFintscoreReport']),
    openPurchaseReportDrawer() {
      this.$refs.drawer_purchase_fintscore_report.viewDetails()
    },
    async generateFintscoreHandler() {
      let message = "Are you sure you want to generate FintScore report?";
      if (confirm(message) == true) {
        this.is_loading_refresh = true
        let report_id = this.activeCreditReport.credit_report_id
        try {
          await this.generateFintscoreReport(report_id)
          await this.getAllFintscoreReport(this.activeCustomer.customer_id)
          _gNotif.notifySuccess('<b>FintScore report - Successfully Generated.')
        } catch (e) {
          _gNotif.notifyError(e)
        }
        this.is_loading_refresh = false
      }
    },
    async refreshCTOSReport() {
      this.is_loading_refresh = true
      await this.getCreditReport()
      this.is_loading_refresh = false
      _gNotif.notifySuccess('<b>CTOS report - Successfully Refreshed.')
    },
    async syncFromSas() {
			swal.fire({
				title: 'Confirmation',
				text: "Confirm to copy latest credit report purchase from sas ?",
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					_gHlp.setLoading('fetch_credit_report')
					this.is_loading_refresh = true
					this.syncLatestSasCreditReport(this.activeCustomer.sas_im2u_id).then(resp =>{
						_gHlp.removeLoading('fetch_credit_report')
						_gNotif.notifySuccess('<b>CTOS report - Successfully sync with sas.')
					}).catch(err => {
						_gHlp.removeLoading('fetch_credit_report')
					})
				}
			});
			
    }
  }
}
</script>